import { WatcherFunction } from '..'
import { watchSaveRequest } from './save'
import { watchSyncDraftRequest } from './sync'

export const draftsSagas: ReadonlyArray<WatcherFunction> = [watchSaveRequest, watchSyncDraftRequest]
